import text from "components/results/analysis-results/text";
import {
  AnalysisItem,
  GroupTableType,
  LegendItem,
  LocationItem
} from "helpers/models";
import { Content } from "pdfmake/interfaces";
import filterLayerGroup from "report/common/filter-layer-group";
import gap from "report/common/gap";
import getTitle from "report/common/title";
import aggregation from "./aggregation/aggregation";
import getNumberOfLocations from "./number-of-locations/index";
import pageEchart from "./page/page";

const get = async (
  t: any,
  locationItems: LocationItem[],
  analysisItems: AnalysisItem[],
  legendItems: LegendItem[],
  aggregationUnits: string[],
  currency: string
): Promise<Content[]> => {
  const aggregationUnitsTiv = aggregationUnits.filter(
    (item) => item !== "numberOfLocations"
  );

  const tivTable: Record<string, GroupTableType> = aggregation(
    locationItems,
    analysisItems,
    legendItems,
    aggregationUnitsTiv
  );

  const layersWithOnlySpecificLabels = filterLayerGroup(tivTable);

  const pageArray = await Promise.all(
    Object.keys(tivTable).map(async (key) => {
      const translateTitle = t(`locations.${key}`);

      const title = key.startsWith("number")
        ? translateTitle
        : translateTitle + "(" + currency + ")";

      const layerTable = tivTable[key];

      const idArray = layersWithOnlySpecificLabels[key];

      idArray.forEach((id) => {
        delete layerTable[id];
      });

      const pageEchartArray = await pageEchart(t, layerTable, title);
      const idText = text(t, idArray);

      pageEchartArray.push(idText);
      
      // pageEchartArray.push(page());

      return pageEchartArray;
    })
  );

  const pageData = pageArray.flat();

  return [
    getTitle(t("report.Analysis Overview")),
    gap(10),
    aggregationUnits.includes("numberOfLocations")
      ? await getNumberOfLocations(t, analysisItems, legendItems)
      : [],
    ...pageData
  ];
};

export default get;
